import { AttachmentCategory } from '../../../../../../enums/Attachments';
import { enums } from 'edrolo-ui';

interface PillMap {
  [key: string]: {
    iconName: enums.Icons;
    pillColor: enums.ColorHue;
  };
}

const pillMap: PillMap = {
  [AttachmentCategory.WORKSHEET]: {
    iconName: enums.Icons.WORKSHEET,
    pillColor: enums.ColorHue.YELLOW,
  },
  [AttachmentCategory.FRAMEWORK]: {
    iconName: enums.Icons.FRAMEWORK,
    pillColor: enums.ColorHue.YELLOW,
  },
  [AttachmentCategory.RISK_ASSESSMENT]: {
    iconName: enums.Icons.RISK_ASSESS,
    pillColor: enums.ColorHue.RED,
  },
  [AttachmentCategory.STUDY_NOTES]: {
    iconName: enums.Icons.STUDY_NOTES,
    pillColor: enums.ColorHue.BLUE,
  },
  [AttachmentCategory.UNIT_PLAN]: {
    iconName: enums.Icons.UNIT_PLAN,
    pillColor: enums.ColorHue.TEAL,
  },
  [AttachmentCategory.TEXTBOOK]: {
    iconName: enums.Icons.TEXTBOOK,
    pillColor: enums.ColorHue.INDIGO,
  },
  [AttachmentCategory.ASSESSMENT]: {
    iconName: enums.Icons.PENCIL_CHECK,
    pillColor: enums.ColorHue.TEAL,
  },
};

const defaultPillSpec = {
  iconName: enums.Icons.ATTACHMENT,
  pillColor: enums.ColorTheme.PRIMARY,
};

export function getPillSpecs(category: AttachmentCategory) {
  return pillMap[category] || defaultPillSpec;
}
